import { CustomMenuItem, isPathSelected } from "./getItem";

export const navItems: CustomMenuItem[] = [
  {
    path: "/frontpage",
    label: "Hjem",
    icon: "pi pi-fw pi-home",

    isSelected: () =>
      isPathSelected(/^\/?$/) || isPathSelected(/^\/?frontpage$/i),
  },
  {
    path: "/personnel",
    label: "Personalia",
    icon: "pi pi-fw pi-user-edit",

    isSelected: () => isPathSelected(/^\/?personnel$/i),
  },
  {
    path: "/timesheets",
    label: "Timeliste",
    icon: "pi pi-fw pi-clock",

    isSelected: () => isPathSelected(/^\/?timesheets$/i),
  },
  {
    path: "/messages",
    label: "Postkasse",
    icon: "pi pi-fw pi-envelope",

    isSelected: () => isPathSelected(/^\/?messages$/i),
  },
  {
    path: "/documents",
    label: "Dokumenter",
    icon: "pi pi-fw pi-file",

    isSelected: () => isPathSelected(/^\/?documents$/i),
  },
];
